<script setup>
    import { ref, computed, onMounted, getCurrentInstance } from 'vue'
    import { useRouter, RouterLink } from 'vue-router'
    import SNBAdmin from '../../../../../layouts/nav/SNBAdmin.vue'
    import insightsFAQService from "../../../../user/services/insights/insightsFAQService";
    import {usePageLoadingStore} from "../../../../../stores/pageLoading";
    import _ from "lodash";
    import moment from 'moment';

    const router = useRouter();
    const loadingStore = usePageLoadingStore()
    const { $pageListBoardNo, $gb } = getCurrentInstance().appContext.config.globalProperties;

    onMounted(() => {
        retrieveList();
    })

    const list = ref([]);
    const currentPage = ref(1);
    const pageSize = ref(30);
    const totalPages = ref(1);
    const totalCount = ref(0);

    const searchOpen = ref(true)

    const searchTypeGroup = ref([
        { label:"작성자", value: "name", placeholder: "작성자명을 입력해주세요."  },
        { label:"아이디", value: "id", placeholder: "아이디를 입력해주세요."  },
        { label:"제목", value: "title", placeholder: "제목을 입력해주세요."  },
    ]);

    const boardGroupListRef = ref(null)
    const searchTypeRef = ref(null)
    const datepickerTermsRef = ref(null);
    
    const searchInputPlaceholder = computed(()=>{
        const option = _.find(searchTypeGroup.value, { value: searchInputs.value.searchType });
        if(option) {
            return option.placeholder;
        } else {
            return '';
        }
    })

    const searchDurationTypeGroup = ref([
        { label:"모든 기간", value: "all" },
        { label:"기간 검색", value: "term" },
    ])

    const pageSizeGroup = ref([
        { label:"30개씩 보기", value: "30" },
        { label:"50개씩 보기", value: "50" },
        { label:"100개씩 보기", value: "100" },
        { label:"500개씩 보기", value: "500" },
    ])

    const searchInputs = ref({
        boardGroupList: [],
        searchType: 'name',
        searchInput: '',
        searchDurationType: 'all',
        startYmd: '',
        endYmd: '',
    })

    const retrieveList = () => {
        const now = new Date();
        const startYmd = searchInputs.value.startYmd ? searchInputs.value.startYmd : moment(now).format('YYYYMMDD');
        const endYmd = searchInputs.value.endYmd ? searchInputs.value.endYmd : moment(new Date(now.setDate(now.getDate() + 30))).format('YYYYMMDD');
        
        let paramObj = {
            boardGroupList: searchInputs.value.boardGroupList,
            pageNo: currentPage.value,
            size: pageSize.value,
            searchType: searchInputs.value.searchType,
            searchInput: searchInputs.value.searchInput,
            startYmd: searchInputs.value.searchDurationType === 'all' ? '' : startYmd,
            endYmd: searchInputs.value.searchDurationType === 'all' ? '' : endYmd,
        };

        loadingStore.loading = true;
        insightsFAQService.retrieveAllPaging(paramObj)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalCount.value = result.totalElements;
                    totalPages.value = result.totalPages;
                    list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                }
            }).catch( (error) =>  {
            loadingStore.loading = false;
            console.log(error);
        });
    }


    const onSelectSearchTypeGroup = (option) => {
        searchInputs.value.searchType = option.value;
    }

    const clearSearchInput = () => {
        searchInputs.value.searchType = 'name';
        searchInputs.value.searchInput = '';
        searchInputs.value.searchDurationType = 'all';
        searchInputs.value.boardGroupList = $gb['BOARD_GROUP_FAQ'].map(option => option.value) // 전체 데이터 넣어주기
        searchInputs.value.startYmd = '';
        searchInputs.value.endYmd = '';
        
        boardGroupListRef.value.initOptions();
        searchTypeRef.value.initSelectedOption(searchInputs.value.searchType);
        datepickerTermsRef.value.initDates();
    }

    const onClickSearch = () => {
        currentPage.value = 1;
        retrieveList();
    }

    const onSelectPage = (pageNo) => {
        currentPage.value = pageNo;
        retrieveList();
    }

    const onSelectPageSize = (option) => {
        pageSize.value = option.value;
        currentPage.value = 1;
        retrieveList();
    }
</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>FAQ</h3>
        </div>
        <div class="filter-wrap" :class="{'open': searchOpen}">
            <p @click="searchOpen = !searchOpen">검색</p>
            <div class="filter">
                <dl>
                    <dt>구분</dt>
                    <dd>
                        <KSACheckBoxGroup
                            ref="boardGroupListRef"
                            className="mr-md"
                            name="userGbList"
                            v-model="searchInputs.boardGroupList"
                            :options="$gb['BOARD_GROUP_FAQ']" />
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <KSASelect ref="searchTypeRef" :options="searchTypeGroup" class="select" @selectOption="onSelectSearchTypeGroup"/>
                    </dt>
                    <dd>
                        <KSAInput class="text-box" v-model="searchInputs.searchInput" :placeholder="searchInputPlaceholder" />
                    </dd>
                </dl>
                <dl>
                    <dt>
                        작성일
                    </dt>
                    <dd class="text-box">
                        <div class="grid">
                            <template v-for="group in searchDurationTypeGroup">
                                <KSARadioButton class="mr-md" name="searchDurationGb" :label="group.label" v-model="searchInputs.searchDurationType" :value="group.value" />
                            </template>
                            <div style="display: inline-block;" v-show="searchInputs.searchDurationType !== 'all'">
                                <KSADatepickerTerms
                                    ref="datepickerTermsRef"
                                    :startDate="searchInputs.startYmd"
                                    :endDate="searchInputs.endYmd"
                                    @update:startDate="(value)=> searchInputs.startYmd = value"
                                    @update:endDate="(value)=> searchInputs.endYmd = value"
                                />
                            </div>
                        </div>
                    </dd>
                </dl>
                <div class="btn-wrap">
                    <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                    <KSAPrimaryButton text="검색" @click="onClickSearch" />
                </div>
            </div>
        </div>
        <div class="list-top">
            <div class="grid">
                <KSASecondaryButton class="gray_button" text="FAQ 작성" @click="router.push({name: 'CSFAQCreate'})" />
            </div>
        </div>
        <div class="list-top">
            <p>총 게시물 <span>{{ $number(totalCount) }}</span>개</p>
            <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
        </div>
        <div class="table-form">
            <table class="horizontal">
                <tr>
                    <th>NO</th>
                    <th>구분</th>
                    <th>제목</th>
                    <th>작성자</th>
                    <th>아이디</th>
                    <th>작성일</th>
                </tr>
                <tr v-for="faq in list">
                    <td>{{faq.boardNo}}</td>
                    <td>{{ $gbNameKR('BOARD_GROUP_FAQ', faq.boardGroup) }}</td>
                    <td class="link text-left"><RouterLink :to="{name: 'CSFAQDetail', params:{id: faq.boardId}}">{{faq.title}}</RouterLink></td>
                    <td>{{ faq.createUserName }}</td>
                    <td>{{faq.createUserLoginId}}</td>
                    <td>{{ $yyyymmddHHmmss(faq.createDate) }}</td>
                </tr>
                <tr v-if="list.length === 0">
                    <td colspan="6">검색 결과가 없습니다.</td>
                </tr>
            </table>
        </div>
        <Paginate
            v-if="list.length > 0"
            v-model="currentPage"
            :page-count="totalPages"
            :click-handler="onSelectPage"
        />
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../../assets/scss/theme";

</style>